export const languageOptions = {
  'en': {
    code: "en",
    name: "English",
    country_code: "en",
    icon: "assets/en.png"
  }, 
  'tr': {
    code: "tr",
    name: "Türkçe",
    country_code: "tr",
    icon: "assets/tr.png"
  },
}